/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2022
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useSelector } from "react-redux";

import DocumentUploadModal from "../summary/DocumentUploadModal";
import { setModeStatusForPricingSubmitted } from "../../../api/bids";
import messages from "../../../helpers/messages";

function SubmitPricingModal({ handleClose, bidId }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const { user } = useSelector(state => state.user);

  const handleModeStatusForPricingSubmitted = () => {
    setIsLoading(true);
    setIsError(false);
    setModeStatusForPricingSubmitted(bidId, user.userRoleForManagementUser)
      .then(() => {
        setIsSuccess(true);
        setIsLoading(false);
      })
      .catch(() => {
        setIsError(true);
        setIsLoading(false);
      });
  };

  return (
    <DocumentUploadModal
      bidId={bidId}
      handleClose={handleClose}
      modalTitle={messages.pricedBidSubmission.defaultMessage}
      modalContent={messages.submitPricingModalBodyMessage.defaultMessage}
      checkboxContent={
        messages.submitPricingModalCheckboxMessage.defaultMessage
      }
      buttonText={messages.submitPricing.defaultMessage}
      buttonStyle={{ minWidth: "148px" }}
      onSuccess={handleModeStatusForPricingSubmitted}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      alertTitle={messages.submissionComplete.defaultMessage}
      alertMessage={messages.pricingHasBeenSuccessfullySubmitted.defaultMessage}
      alertModalLarge={true}
      alertModalStyle={{ minHeight: "178px" }}
    />
  );
}

export default SubmitPricingModal;
